// src/pages/ContentEditor/index.js
import ContentEditor from './ContentEditor';
export default ContentEditor;